module.exports = __webpack_public_path__ + "img/apple1.700b33b5.png";